import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m14 6 4 4-4 4" stroke={color} strokeWidth="2" />
    <path d="M18 10h-8a4 4 0 0 0 0 8h8" stroke={color} strokeWidth="2" />
  </svg>
);
